export const accountJournalRoutes = [
  {
    path: "/accountjournal",
    component: () => import("@/views/AccountJournal/List.vue"),
  },
  {
    path: "/accountjournal/transfer",
    component: () => import("@/views/AccountJournal/AccountTransfer.vue"),
  },
];
